import { render, staticRenderFns } from "./Photopea.vue?vue&type=template&id=afb05710&"
import script from "./Photopea.vue?vue&type=script&lang=js&"
export * from "./Photopea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports